<script>
    export default {
        
    }
</script>

<template>
    <div class="event event-skeleton is-flex">
        <div class="event-info">
            <time class="event-date">
                <span class="event-date-date"><progress class="progress is-small is-grey" max="100"></progress></span>
                <span class="event-date-time"><progress class="progress is-small is-grey" max="100"></progress></span>
            </time>
            <div class="event-location">
                <progress class="progress is-small is-grey" max="100"></progress>
            </div>
        </div>
        <figure class="event-image is-skeleton">
            <img alt="Loading" src="https://placehold.co/180x180?text= ">
        </figure>
        <div class="event-content is-flex-grow-1">
            <div class="event-content-text">
                <div class="event-genres tags">
                    <span class="tag is-skeleton">loading</span>
                </div>
                <h3 class="title is-4 event-title"><progress class="progress is-grey" max="100"></progress></h3>
                <p class="block has-text-weight-medium event-subtitle mt-auto"><progress class="progress is-small is-grey" max="100"></progress></p>
            </div>
            <span class="button is-rounded is-grey is-skeleton">
                <span>Loading</span>
                <span class="icon">
                    <img src="/svg/arrow.svg" alt="arrow right" width="12" height="10" loading="lazy">
                </span>
            </span>
        </div>
    </div>
</template>
